export const bannerOuter = {
    width: '100%',
    height: '77px',
    position: 'fixed' as const,
    top: 0,
    left: 0,
    zIndex: 3,
    background: '#E10600',
};

export const bannerBarStyle = {
    width: '100%',
    left: 0,
    top: 0,
    position: 'static' as const,
    background: 'transparent',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 20,
    display: 'inline-flex',
};

export const bannerRow = {
    width: '100%',
    height: '100%',
    maxWidth: 1920,
    margin: '0 auto',
    paddingTop: 16,
    paddingBottom: 16,
    flex: '1 1 0',
    justifyContent: 'space-between',
    alignItems: 'center',
    display: 'flex',
    paddingLeft: 64,
    paddingRight: 64,
};

export const logoGroup = {
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: 32,
    display: 'flex',
};

export const logoInnerGroup = {
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: 16,
    display: 'flex',
};

export const logoBox = {
    width: 152.55,
    height: 45,
    position: 'relative' as const,
    overflow: 'hidden',
};

export const userGroup = {
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: 24,
    display: 'flex',
};

export const userRow = {
    justifyContent: 'flex-end',
    alignItems: 'center',
    display: 'inline-flex',
};

export const userAvatarBox = {
    width: 24,
    height: 24,
    position: 'relative' as const,
    overflow: 'hidden',
    maxWidth: 24,
    maxHeight: 24,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    bgcolor: '#fff',
    color: '#E10600'
};

export const userNameWrap = {
    flexDirection: 'column' as const,
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    display: 'inline-flex',
};

export const userNameInner = {
    flexDirection: 'column' as const,
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    display: 'flex',
};

export const userName = {
    color: 'white',
    paddingLeft: 1,
    fontSize: 14,
    fontFamily: 'Poppins, sans-serif',
    fontWeight: 500,
    lineHeight: '20px',
    wordWrap: 'break-word' as const,
};
